import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from '../../endpoints';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceAccounts = /*#__PURE__*/function (_Service) {
  _inherits(ServiceAccounts, _Service);

  var _super = _createSuper(ServiceAccounts);

  function ServiceAccounts() {
    _classCallCheck(this, ServiceAccounts);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceAccounts, [{
    key: "me",
    value: function me() {
      return this.axiosInstance.get(ENDPOINTS.accounts.me);
    }
  }, {
    key: "fetchUserType",
    value: function fetchUserType(_ref) {
      var email = _ref.email;
      return this, this.axiosInstance.get("".concat(ENDPOINTS.accounts.root, "/user_type"), {
        params: {
          email: email
        }
      });
    }
  }, {
    key: "migrateUser",
    value: function migrateUser(_ref2) {
      var email = _ref2.email,
          toType = _ref2.toType;
      return this.axiosInstance.post("".concat(ENDPOINTS.accounts.root, "/migrate_user"), {
        email: email,
        to_type: toType
      });
    }
  }, {
    key: "checkUserExistence",
    value: function checkUserExistence(_ref3) {
      var email = _ref3.email,
          phone_number = _ref3.phone_number;
      return this.axiosInstance.post(ENDPOINTS.accounts.checkUserExistence, {
        email: email,
        phone_number: phone_number
      });
    }
  }, {
    key: "login",
    value: function login(_ref4) {
      var email = _ref4.email,
          password = _ref4.password;
      return this.axiosInstance.post(ENDPOINTS.accounts.login, {
        email: email,
        password: password
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer null"
        }
      });
    }
  }, {
    key: "createSetupCheckoutSession",
    value: function createSetupCheckoutSession(_ref5) {
      var employerId = _ref5.employerId,
          companyId = _ref5.companyId;
      return this.axiosInstance.get(ENDPOINTS.accounts.setupCheckoutSession, {
        params: {
          employer_id: employerId,
          company_id: companyId
        }
      });
    }
  }, {
    key: "getIntercomContactId",
    value: function getIntercomContactId(email) {
      return this.axiosInstance.get(ENDPOINTS.accounts.getIntercomContactId, {
        params: {
          email: email
        }
      });
    }
  }, {
    key: "passwordForgot",
    value: function passwordForgot(email) {
      return this.axiosInstance.get(ENDPOINTS.accounts.forgotPassword, {
        params: {
          email: email
        }
      });
    }
  }, {
    key: "fetchForm",
    value: function fetchForm(id) {
      return this.axiosInstance.get("".concat(ENDPOINTS.accounts.formId, "/").concat(id));
    }
  }, {
    key: "fetchFormSession",
    value: function fetchFormSession(form_id) {
      return this.axiosInstance.get(ENDPOINTS.accounts.formSessionId, {
        params: {
          form_id: form_id
        }
      });
    }
  }, {
    key: "resetPassword",
    value: function resetPassword(_ref6) {
      var id = _ref6.id,
          newPassword = _ref6.newPassword,
          jwt = _ref6.jwt;
      return this.axiosInstance.post(ENDPOINTS.accounts.resetPassword, {
        id: id,
        password: newPassword
      }, {
        headers: {
          Authorization: "Bearer ".concat(jwt)
        }
      });
    } // For new sign_up

  }, {
    key: "createAccount",
    value: function createAccount(_ref7) {
      var email = _ref7.email,
          phone_number = _ref7.phone_number,
          redirectURL = _ref7.redirectURL;
      return this.axiosInstance.post(ENDPOINTS.accounts.signUp, {
        email: email,
        phone_number: phone_number,
        redirect_url: redirectURL
      });
    }
  }, {
    key: "signUp",
    value: function signUp(_ref8) {
      var id = _ref8.id,
          email = _ref8.email,
          password = _ref8.password;
      return this.axiosInstance.post(ENDPOINTS.accounts.signUp, {
        id: id,
        email: email,
        password: password
      });
    }
  }, {
    key: "updateUser",
    value: function updateUser(params) {
      return this.axiosInstance.patch(ENDPOINTS.accounts.root, params);
    }
  }, {
    key: "passwordlessLogin",
    value: function passwordlessLogin(email, redirectUrl) {
      return this.axiosInstance.post(ENDPOINTS.accounts.passwordlessLogin, {
        email: email,
        redirect_url: redirectUrl
      });
    } // Passwordless login by phone_number

  }, {
    key: "phoneNumberLogin",
    value: function phoneNumberLogin(phoneNumber) {
      return this.axiosInstance.post(ENDPOINTS.accounts.passwordlessLogin, {
        phone_number: phoneNumber
      });
    } // when requested login by phone_number

  }, {
    key: "verifyOTPCode",
    value: function verifyOTPCode(_ref9) {
      var otpCode = _ref9.otpCode,
          phoneNumber = _ref9.phoneNumber;
      return this.axiosInstance.post(ENDPOINTS.accounts.login, {
        otp_code: otpCode,
        phone_number: phoneNumber
      });
    } // when requested login by email

  }, {
    key: "verifyMagicLink",
    value: function verifyMagicLink(token) {
      return this.axiosInstance.post(ENDPOINTS.accounts.login, {
        token: token
      });
    }
  }, {
    key: "sendVerificationPhoneOtp",
    value: function sendVerificationPhoneOtp(params) {
      var _ref10 = params || {},
          phoneNumber = _ref10.phoneNumber,
          gmapsPlaceId = _ref10.gmapsPlaceId;

      return this.axiosInstance.get(ENDPOINTS.accounts.phoneOtpVerification, {
        params: {
          phone_number: phoneNumber,
          gmaps_place_id: gmapsPlaceId
        }
      });
    } // for verifying the phone_number on user_settings

  }, {
    key: "verifyPhoneOtp",
    value: function verifyPhoneOtp(_ref11) {
      var otpCode = _ref11.otpCode,
          gmapsPlaceId = _ref11.gmapsPlaceId;
      return this.axiosInstance.post(ENDPOINTS.accounts.verifyPhoneOtp, {
        otp_code: otpCode,
        gmaps_place_id: gmapsPlaceId
      });
    }
  }, {
    key: "updateAuthenticationDetails",
    value: function updateAuthenticationDetails(_ref12) {
      var email = _ref12.email,
          phoneNumber = _ref12.phoneNumber;
      return this.axiosInstance.patch(ENDPOINTS.accounts.updateAuthenticationEmail, {
        email: email,
        phone_number: phoneNumber
      });
    }
  }, {
    key: "verifyEmail",
    value: function verifyEmail(_ref13) {
      var token = _ref13.token;
      return this.axiosInstance.post(ENDPOINTS.accounts.verifyEmail, {
        token: token
      });
    } // When user logs out

  }, {
    key: "logout",
    value: function logout() {
      return this.axiosInstance.get(ENDPOINTS.accounts.logout);
    } // Delete account

  }, {
    key: "delete",
    value: function _delete(_ref14) {
      var userId = _ref14.userId;
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.accounts["delete"]).concat(userId ? "/".concat(userId) : ''));
    } // GET RESTAURANT EXPLORATION POPUP DETAILS

  }, {
    key: "restaurant_exploration_popup_details",
    value: function restaurant_exploration_popup_details() {
      return this.axiosInstance.get("".concat(ENDPOINTS.accounts.restaurant_exploration_popup_details));
    }
  }, {
    key: "listFlexibleSlots",
    value: function listFlexibleSlots(_ref15) {
      var limit = _ref15.limit,
          offset = _ref15.offset,
          organizationId = _ref15.organizationId,
          status = _ref15.status,
          dateTruncExpiresAt = _ref15.dateTruncExpiresAt;
      return this.axiosInstance.get(ENDPOINTS.accounts.flexibleSlots, {
        params: {
          limit: limit,
          offset: offset,
          organization_id: organizationId,
          status: status,
          date_trunc_expires_at: dateTruncExpiresAt
        }
      });
    }
  }, {
    key: "cancelFlexibleSlot",
    value: function cancelFlexibleSlot(_ref16) {
      var slotIds = _ref16.slotIds;
      return this.axiosInstance.post(ENDPOINTS.accounts.cancelFlexibleSlot, {
        slot_ids: slotIds
      });
    }
  }, {
    key: "activateFlexibleSlot",
    value: function activateFlexibleSlot(_ref17) {
      var organizationId = _ref17.organizationId;
      return this.axiosInstance.post(ENDPOINTS.accounts.activateFlexibleSlot, {
        organization_id: organizationId
      });
    }
  }, {
    key: "updateFlexibleSlot",
    value: function updateFlexibleSlot(_ref18) {
      var id = _ref18.id,
          data = _ref18.data;
      return this.axiosInstance.patch("".concat(ENDPOINTS.accounts.flexibleSlots, "/").concat(id), data);
    }
  }, {
    key: "issueFreeSlot",
    value: function issueFreeSlot(_ref19) {
      var companyId = _ref19.companyId;
      return this.axiosInstance.post(ENDPOINTS.accounts.freeSlot, {
        company_id: companyId
      });
    }
  }, {
    key: "getFlexibleSlotPaymentSession",
    value: function getFlexibleSlotPaymentSession(_ref20) {
      var companyId = _ref20.companyId,
          slots = _ref20.slots,
          type = _ref20.type,
          discount = _ref20.discount,
          tag = _ref20.tag,
          autonomous = _ref20.autonomous,
          cancel_url = _ref20.cancel_url,
          coupon = _ref20.coupon,
          product = _ref20.product;
      return this.axiosInstance.post(ENDPOINTS.accounts.flexibleSlotPaymentSession, {
        company_id: companyId,
        slots: slots,
        type: type,
        discount: discount,
        tag: tag,
        autonomous: autonomous,
        cancel_url: cancel_url,
        coupon: coupon,
        product: product
      });
    }
  }, {
    key: "listEmployerUserContacts",
    value: function listEmployerUserContacts(_ref21) {
      var limit = _ref21.limit,
          offset = _ref21.offset,
          organizationId = _ref21.organizationId,
          searchVector = _ref21.searchVector;
      return this.axiosInstance.get(ENDPOINTS.accounts.employerUserContact, {
        params: {
          limit: limit,
          offset: offset,
          organization_id: organizationId,
          search_vector: searchVector
        }
      });
    }
  }, {
    key: "createEmployerUserContact",
    value: function createEmployerUserContact(data) {
      return this.axiosInstance.post(ENDPOINTS.accounts.employerUserContact, data);
    }
  }, {
    key: "fetchEmployerUserContact",
    value: function fetchEmployerUserContact(user_id) {
      return this.axiosInstance.get("".concat(ENDPOINTS.accounts.employerUserContact, "/").concat(user_id));
    }
  }, {
    key: "updateEmployerUserContact",
    value: function updateEmployerUserContact(params, userId) {
      var headers = params instanceof FormData ? {
        'content-type': 'multipart/form-data'
      } : {
        'content-type': 'application/json'
      };
      return this.axiosInstance.patch("".concat(ENDPOINTS.accounts.employerUserContact, "/").concat(userId), params, {
        headers: headers
      });
    }
  }, {
    key: "deleteEmployerUserContact",
    value: function deleteEmployerUserContact(_ref22) {
      var userId = _ref22.userId;
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.accounts.employerUserContact, "/").concat(userId));
    }
  }, {
    key: "getEmployerUserContactAccessLink",
    value: function getEmployerUserContactAccessLink(eucId) {
      return this.axiosInstance.get(ENDPOINTS.accounts.employerUserContactAccessLink, {
        params: {
          user_id: eucId
        }
      });
    }
  }, {
    key: "deleteSecondaryContact",
    value: function deleteSecondaryContact(_ref23) {
      var id = _ref23.id;
      return this.axiosInstance["delete"]("".concat(ENDPOINTS.accounts.secondaryContacts, "/").concat(id));
    }
  }, {
    key: "cancelSlots",
    value: function cancelSlots(_ref24) {
      var stripeSubscriptionId = _ref24.stripeSubscriptionId,
          flexibleSlotIds = _ref24.flexibleSlotIds,
          employerSubscriptionFeedback = _ref24.employerSubscriptionFeedback,
          _ref24$createFeedback = _ref24.createFeedback,
          createFeedback = _ref24$createFeedback === void 0 ? true : _ref24$createFeedback;
      return this.axiosInstance.post(ENDPOINTS.accounts.cancelSlots, _objectSpread({
        create_feedback: createFeedback,
        stripe_subscription_id: stripeSubscriptionId,
        slot_ids: flexibleSlotIds
      }, employerSubscriptionFeedback));
    }
  }, {
    key: "flexibleSlotInstallmentPayment",
    value: function flexibleSlotInstallmentPayment(_ref25) {
      var companyId = _ref25.companyId,
          slots = _ref25.slots,
          discount = _ref25.discount,
          type = _ref25.type;
      return this.axiosInstance.post("".concat(ENDPOINTS.accounts.flexibleSlots, "/pay_in_installments"), {
        company_id: companyId,
        slots: slots,
        type: type,
        discount: discount
      });
    }
  }, {
    key: "buyFlexibleSlots",
    value: function buyFlexibleSlots(_ref26) {
      var companyId = _ref26.companyId,
          slots = _ref26.slots,
          discount = _ref26.discount,
          type = _ref26.type,
          product = _ref26.product;
      return this.axiosInstance.post("".concat(ENDPOINTS.accounts.flexibleSlots, "/buy"), {
        company_id: companyId,
        slots: slots,
        type: type,
        discount: discount,
        product: product
      });
    }
  }, {
    key: "createAnnualSubscription",
    value: function createAnnualSubscription(_ref27) {
      var companyId = _ref27.companyId,
          slots = _ref27.slots;
      return this.axiosInstance.post(ENDPOINTS.accounts.annualSubscription, {
        company_id: companyId,
        slots: slots
      });
    }
  }]);

  return ServiceAccounts;
}(Service);

export var createAccountService = function createAccountService(_ref28) {
  var baseUrl = _ref28.baseUrl,
      jwt = _ref28.jwt;
  return new ServiceAccounts(dynamicAxios(baseUrl, jwt));
};
export function useAccountsService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceAccounts(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useAccountsService;
export * from './types';